<template>

    <div 
        class="input-container"
    >
        <section>

            <label>
                <!-- <v-icon :color="$vuetify.theme.themes['dark']['primary']">
                    mdi-shape-outline
                </v-icon> -->
                圖卡種類選擇
            </label>							
            
            <v-container
                class="px-0"
                fluid
                style="padding:0;"
            >
                <v-radio-group
                    @change="changeCardType(row)"
                    v-model="row" 
                    row 
                    color="primary"
                >

                    <v-radio
                        label= "一般行銷圖卡"
                        :value= "0"
                        color="primary"
                    ></v-radio>

                    <v-radio
                        label= "縣市行銷圖卡"
                        :value= "1"
                        color="primary"
                    ></v-radio>

                </v-radio-group>
                
            </v-container>

            <v-container v-if="row == 1" style="padding: 0px; color: #777;" class="d-flex" color="primary">
                
                <v-row>
                    <v-col>
                        <v-select
                            :items="Object.values(cities)"
                            label="縣市"
                            v-model="selectedCity"
                            color="primary"
                            @change="changeCity"
                        ></v-select>
                    </v-col>
                    <v-col>
                        <v-select
                            :items="filteredDistricts"
                            label="行政區域"
                            v-model="selectedDistrict"
                            color="primary"
                            @change="changeDistricst"
                        ></v-select>
                    </v-col>
                </v-row>

            </v-container>

        </section>

    </div>

</template>

<script>

export default {
    props:  {
        oldSettingCardRow: Number,
        default_city: String,
        default_district: String,
        default_row: Number,
    },
    name: 'MarketingCardCategories',
    components: {

    },
    data() {
        return{
            // 縣市或一般行銷圖卡的選擇，單選按鈕選定的值
		    row: this.default_row,

            // 縣市下拉式選單需用參數
            // city_item: taiwan_add.city,
            // district_item: taiwan_add.district,
            // districts: [{name:"選擇",postcode:""}],
            // choosed_city: "",
            // choosed_district: "",

            selectedCity: "",
            selectedDistrict: "",
            districts: [],
            cities_districts: [
                { name: "臺北市", districts: ["全區","中正區", "大同區", "中山區", "松山區", "大安區", "萬華區", "信義區", "士林區", "北投區", "內湖區", "南港區", "文山區"] },
                { name: "基隆市", districts: ["全區","仁愛區","信義區","中正區","中山區","安樂區","暖暖區","七堵區"] },
                { name: "新北市", districts: ["全區","板橋區", "三重區", "中和區", "永和區", "新莊區", "新店區", "樹林區", "鶯歌區", "三峽區", "淡水區", "汐止區", "瑞芳區", "土城區", "蘆洲區", "五股區", "泰山區", "林口區", "深坑區", "石碇區", "坪林區", "三峡區", "烏來區", "貢寮區", "金山區", "萬里區", "雙溪區", "石門區", "八里區", "平溪區", "瑞芳區", "貢寮區", "雙溪區", "龜山區", "蘆洲區", "五股區", "泰山區", "林口區", "深坑區", "石碇區", "坪林區", "三峽區", "烏來區", "貢寮區", "金山區", "萬里區", "雙溪區", "石門區", "八里區", "平溪區", "瑞芳區", "貢寮區", "雙溪區", "龜山區", "八里區", "平溪區"] },
                { name: "宜蘭縣", districts: ["全區","宜蘭市","羅東鎮","蘇澳鎮","頭城鎮","礁溪鄉","壯圍鄉","員山鄉","冬山鄉","五結鄉","三星鄉","大同鄉","南澳鄉"] },
                { name: "新竹市", districts: ["全區","東區", "北區", "香山區"] },
                { name: "桃園市", districts: ["全區","桃園區", "中壢區", "平鎮區", "八德區", "楊梅區", "蘆竹區", "龜山區", "龍潭區", "大溪區", "新屋區", "觀音區", "復興區"] },
                { name: "新竹縣", districts: ["全區","竹北市", "竹東鎮", "新埔鎮", "關西鎮", "湖口鄉", "橫山鄉", "新豐鄉", "芎林鄉", "寶山鄉", "北埔鄉", "峨眉鄉", "尖石鄉", "五峰鄉"] },
                { name: "苗栗縣", districts: ["全區","苗栗市", "頭份市", "竹南鎮", "後龍鎮", "通霄鎮", "苑裡鎮", "卓蘭鎮", "造橋鄉", "西湖鄉", "泰安鄉", "三義鄉", "南庄鄉", "獅潭鄉", "大湖鄉", "卓蘭鎮", "公館鄉", "銅鑼鄉", "頭屋鄉", "三灣鄉"] },
                { name: "臺中市", districts: ["全區","中區", "東區", "南區", "西區", "北區", "北屯區", "西屯區", "南屯區", "豐原區", "大里區", "太平區", "清水區", "沙鹿區", "梧棲區", "后里區", "神岡區", "潭子區", "大雅區", "新社區", "石岡區", "外埔區", "大安區", "霧峰區", "龍井區", "大肚區", "南投市", "太平市", "豐原市"] },
                { name: "彰化縣", districts: ["全區","彰化市", "員林市", "和美鎮", "鹿港鎮", "溪湖鎮", "北斗鎮", "二林鎮", "田中鎮", "花壇鄉", "芬園鄉", "秀水鄉", "福興鄉", "線西鄉", "埔心鄉", "埔鹽鄉", "大城鄉", "竹塘鄉", "社頭鄉", "永靖鄉", "埤頭鄉", "溪州鄉", "大村鄉", "埔盛鄉", "北斗鎮", "二林鎮", "田中鎮", "花壇鄉", "芬園鄉", "秀水鄉", "福興鄉", "線西鄉", "埔心鄉", "埔鹽鄉", "大城鄉", "竹塘鄉", "社頭鄉", "永靖鄉", "埤頭鄉", "溪州鄉", "大村鄉", "埔盛鄉"] },
                { name: "南投縣", districts: ["全區","南投市", "埔里鎮", "草屯鎮", "竹山鎮", "集集鎮", "名間鄉", "鹿谷鄉", "中寮鄉", "魚池鄉", "國姓鄉", "水里鄉", "信義鄉", "仁愛鄉"] },
                { name: "雲林縣", districts: ["全區","斗六市", "斗南鎮", "虎尾鎮", "西螺鎮", "土庫鎮", "北港鎮", "古坑鄉", "大埤鄉", "莿桐鄉", "林內鄉", "二崙鄉", "崙背鄉", "麥寮鄉", "東勢鄉", "褒忠鄉", "臺西鄉", "元長鄉", "四湖鄉", "口湖鄉", "水林鄉"] },
                { name: "嘉義市", districts: ["全區","東區", "西區"] },
                { name: "嘉義縣", districts: ["全區","太保市", "朴子市", "布袋鎮", "大林鎮", "民雄鄉", "溪口鄉", "新港鄉", "六腳鄉", "東石鄉", "義竹鄉", "鹿草鄉", "水上鄉", "中埔鄉","竹崎鄉", "梅山鄉", "番路鄉", "大埔鄉", "阿里山鄉"] },
                { name: "臺南市", districts: ["全區","中西區", "東區", "南區", "北區", "安平區", "安南區", "永康區", "歸仁區", "新化區", "左鎮區", "玉井區", "楠西區", "南化區", "仁德區", "關廟區", "龍崎區", "官田區", "麻豆區", "佳里區", "西港區", "七股區", "將軍區", "學甲區", "北門區", "新營區", "後壁區", "白河區", "東山區", "六甲區", "下營區", "柳營區", "鹽水區", "善化區", "大內區", "山上區", "新市區", "安定區"] },
                { name: "高雄市", districts: ["全區","鼓山區", "左營區", "楠梓區", "三民區", "新興區", "前金區", "苓雅區", "前鎮區", "旗津區", "小港區", "鳳山區", "大寮區", "鳥松區", "林園區", "仁武區", "大樹區", "大社區", "岡山區", "路竹區", "橋頭區", "梓官區", "彌陀區", "永安區", "燕巢區", "田寮區", "阿蓮區", "茄萣區", "湖內區", "旗山區", "美濃區", "六龜區", "內門區", "杉林區", "甲仙區", "桃源區", "那瑪夏區", "茂林區", "茂林區"] },
                { name: "屏東縣", districts: ["全區","屏東市", "潮州鎮", "東港鎮", "恆春鎮", "萬丹鄉", "長治鄉", "麟洛鄉", "九如鄉", "里港鄉", "鹽埔鄉", "高樹鄉", "萬巒鄉", "內埔鄉", "竹田鄉", "新埤鄉", "枋寮鄉", "新園鄉", "崁頂鄉", "林邊鄉", "南州鄉", "佳冬鄉", "琉球鄉", "車城鄉", "滿州鄉", "枋山鄉", "霧臺鄉", "瑪家鄉", "泰武鄉", "來義鄉", "春日鄉", "獅子鄉", "牡丹鄉"] },
                { name: "台東縣", districts: ["全區","台東市", "成功鎮", "關山鎮", "長濱鄉", "海端鄉", "池上鄉", "東河鄉", "鹿野鄉", "延平鄉", "卑南鄉", "金峰鄉", "大武鄉", "達仁鄉", "綠島鄉", "蘭嶼鄉", "太麻里鄉"] },
                { name: "花蓮縣", districts: ["全區","花蓮市", "鳳林鎮", "玉里鎮", "新城鄉", "吉安鄉", "壽豐鄉", "光復鄉", "豐濱鄉", "瑞穗鄉", "萬榮鄉", "卓溪鄉", "富里鄉"] }
            ],    
            cities: {
                "001":"臺北市",
                "002":"基隆市", 
                "003":"新北市", 
                "004":"宜蘭縣", 
                "005":"新竹市", 
                "006":"新竹縣", 
                "007":"桃園市", 
                "008":"苗栗縣", 
                "009":"臺中市", 
                "010":"彰化縣", 
                "011":"南投縣", 
                "012":"嘉義市", 
                "013":"嘉義縣", 
                "014":"雲林縣", 
                "015":"臺南市", 
                "016":"高雄市", 
                "017":"屏東縣", 
                "018":"臺東縣", 
                "019":"花蓮縣"
            },
            filteredDistricts: []
        }
    },
    methods: {
        filterDistricts(current_city_name) {
            let cities = []
            const city = this.cities_districts.find((city) => city.name === current_city_name);
            console.log('filter', city)
            if (city) {
                cities = city.districts
            }
            return cities
        },
        changeCardType(row){
            console.log('changeType:', row)
            this.$emit('handle-row', row)
            if (row === 0) {
                this.selectedCity = ''
                this.selectedDistrict = ''
                this.changeCity()
                this.changeDistricst()
            }
        },
        changeCity(){
            this.filteredDistricts = this.filterDistricts(this.selectedCity)
            this.$emit('selected-city', this.selectedCity)
        },
        changeDistricst(){
            this.$emit('selected-district', this.selectedDistrict)
        }
    },
    computed: {
    },
    watch: {
        // row: {
        //     handler: function(newVal){
        //         console.log('newVal',newVal)
        //         this.$emit('handle-row', newVal)
        //         this.selectedCity = ''
        //         this.selectedDistrict = ''
        //     },
        //     immediate: true
		// },
        // oldSettingCardRow: {
        //     handler: function(newVal) {
        //         if (newVal === 1 && this.oldSettingData !== null) {
        //             this.row = newVal
		// 			let city_item_vals = Object.values(this.cities)
        //             let city_result = city_item_vals.find( value => value === this.oldSettingData.tags.split(',')[1] )
        //             if (city_result) {
        //                 this.selectedCity = this.oldSettingData.tags.split(',')[1]
        //                 this.$emit('selected-city', this.selectedCity)
        //                 this.selectedDistrict = this.oldSettingData.tags.split(',')[0]
        //                 this.$emit('selected-district', this.selectedDistrict)
        //             } else {
        //                 this.selectedCity = this.oldSettingData.tags.split(',')[0]
        //                 this.$emit('selected-city', this.selectedCity)
        //                 this.selectedDistrict = this.oldSettingData.tags.split(',')[1]
        //                 this.$emit('selected-district', this.selectedDistrict)
        //             }
        //         }
        //     },
        //     immediate: true
        // }
    },
    mounted() {
        console.log('this.default_city',this.default_city)
        this.selectedCity = this.default_city
        this.selectedDistrict = this.default_district
        this.row = this.default_row
        console.log('row????', this.row)
        this.changeCity()
        this.changeDistricst()
        this.changeCardType(this.row)
        // console.log('.oldSettingData', this.oldSettingData)
        // console.log('filteredDistricts',this.filteredDistricts)
        // console.log('this.default_city', this.default_city)
        // this.selectedCity = this.default_city
        // this.selectedDistrict = this.default_district
        // this.row = this.default_row
        // console.log('this.selectedCity',this.selectedCity)
        // this.is_load_default = true
        // this.$emit('handle-row', 0)
    }
}    
</script>

<style scoped>
    .input-container {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-bottom: 1em;
    }
    .input-container > section {
        display: flex;
        width: 100%;
        flex-direction: row;
        margin-right: 1em;
        align-items: center;
    }
    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .input-container > section > label > i {
        margin-right: 0.3em;
        color: #409aff;
    }
    .input-container > section > label {
        min-width: 6em;
        display: flex;
        align-items: center;
        font-weight: 200;
        margin-right: 0.5em;
    }
    .input-container > section > input[type="text"] {
        padding: 10px 18px 10px 18px;
        border-radius: .4285rem;
        border-color: #2b3553;
        border: 1px solid #cad1d7;
        width: 100%;
        outline: none;
        transition: all .3s;
    }
    .input-container > section > input[type="text"]:hover, .input-container > section > input[type="text"]:focus{
        border-color: #409aff;
    }

    .input-container > section > .mx-datepicker {
        width: 100%;
    }
</style>